import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [isMobile, setIsMobile] = useState(false);

  const checkMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    const body = document.body;

    if (isOpen && !isMobile) {
      body.classList.add("sidebar-open");
    } else {
      body.classList.remove("sidebar-open");
    }

    // Temizlik
    return () => body.classList.remove("sidebar-open");
  }, [isOpen, isMobile]);

  useEffect(() => {
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      {/* Sidebar */}
      <aside
        className="sidebar-wrapper"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: isMobile ? "80%" : "300px",
          backgroundColor: "#fff",
          boxShadow: "2px 0 5px rgba(0,0,0,0.3)",
          transform: isOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s ease-in-out",
          zIndex: 1050,
          overflowY: "auto",
        }}
      >
        <div
          className="sidebar-header"
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px",
            width: "100%",
          }}
        >
          <div className="logo-icon">
            <img
              style={{
                height: "70px",
                width: "150px",
                display: isMobile ? "block" : "block",
              }}
              src="assets/images/softt.png"
              className="logo-img"
              alt=""
            />
          </div>
          <div className="logo-name flex-grow-1">
            <img
              style={{
                height: "60px",
                width: "260px",
                marginLeft: "-50px",
                marginBottom: "8px",
                display: isMobile ? "none" : "block",
              }}
              src="assets/images/softanabuyuk.png"
              className="logo-img"
              alt=""
            />
          </div>
          <div
            className="sidebar-close"
            onClick={toggleSidebar}
            style={{ marginLeft: "auto", cursor: "pointer" }}
          >
            <span className="material-symbols-outlined">close</span>
          </div>
        </div>

        <div className="sidebar-nav" data-simplebar="true">
          <ul className="metismenu" id="menu">
            <li>
              <Link to="/">
                <div className="parent-icon">
                  <span className="material-symbols-outlined">home</span>{" "}
                </div>
                <div className="menu-title">Anasayfa</div>
              </Link>
            </li>

            <li>
              <Link to="/feedbacks">
                <div className="parent-icon">
                  <span className="material-symbols-outlined">feedback</span>
                </div>
                <div className="menu-title">Geri Dönüşler</div>
              </Link>
            </li>

            <li>
              <a href="javascript:;" className="has-arrow">
                <div className="parent-icon">
                  <span className="material-symbols-outlined">
                    restaurant_menu
                  </span>
                </div>
                <div className="menu-title">Menü</div>
              </a>
              <ul>
                <li>
                  <Link to="/add-blog">
                    <span className="material-symbols-outlined">
                      arrow_right
                    </span>
                    Ürün Ekle
                  </Link>
                </li>
                <li>
                  <Link to="/product-list">
                    <span className="material-symbols-outlined">
                      arrow_right
                    </span>
                    Ürün Listesi
                  </Link>
                </li>
                <li>
                  <Link to="/add-category">
                    <span className="material-symbols-outlined">
                      arrow_right
                    </span>
                    Kategori Ekle
                  </Link>
                </li>
                <li>
                  <Link to="/category-list">
                    <span className="material-symbols-outlined">
                      arrow_right
                    </span>
                    Kategori Listesi
                  </Link>
                </li>
                <li>
                  <Link to="/alergens">
                    <span className="material-symbols-outlined">
                      arrow_right
                    </span>
                    Alerjen Düzenle
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </aside>

      {/* Arka plan overlay (mobilde) */}
      {isOpen && isMobile && (
        <div
          onClick={toggleSidebar}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 999,
          }}
        />
      )}
    </>
  );
};

export default Sidebar;
